import {
  AuthStatus,
  DataSource,
  Location,
  LocationTypeEnum,
  Organization,
  Practitioner,
  User,
} from "../generated/graphql";
import { AccessStatus } from "../lib/accessStatus";

export const PRACTITIONER_LOCATION_SCOPE = {
  All: "ALL",
  Selected: "SELECTED",
} as const;

export type PractitionerLocationScope = (typeof PRACTITIONER_LOCATION_SCOPE)[keyof typeof PRACTITIONER_LOCATION_SCOPE];

export type PractitionerRecord = Pick<User, "firstName" | "lastName" | "name" | "avatarUrl"> &
  Pick<Practitioner, "id" | "employeeNumber" | "emailAddress" | "birthDate" | "status"> & {
    role?: Practitioner["role"];
    motherTongue?: Practitioner["motherTongue"];
    organizationId?: Organization["id"];
    organizationName?: Organization["name"];
    locationScope: PractitionerLocationScope;
    locations: Array<{ id: Location["id"]; name: Location["name"]; type: LocationTypeEnum | null }>;
    practitionerId?: Practitioner["id"];
    sourceSystem?: DataSource | null;
    userId?: User["id"];
    authStatus?: AuthStatus | null;
    accessStatus?: AccessStatus;
  };
